export const NAME = 'assets';
export const LIBRARY_SEARCH_NAME = 'assetLibrary';
export const CONTENT_TYPE_NAME = 'asset';
export const SHAPE_ID = 'ASSET';
export const SHAPE_NAME = 'Asset';
export const ELEMENT_TYPE = 'asset';
